import styled from 'styled-components';
import Image from 'next/legacy/image';

import { pxToRem } from '@yoweb/ui/styles/utils';
import { getRadii, getSpace, getColor } from '@yoweb/ui/styles/utils/theme';
import { Text } from '@yoweb/ui/components/typography';

type ImageWithTitleCardType = {
  image: string;
  title: string;
  imageAltText: string;
};

export const ImageWithTitleCard = ({ image, title, imageAltText }: ImageWithTitleCardType) => (
  <CardContainer>
    <ImageContainer>
      <BackgroundImage>
        <Image src={image} layout="fill" objectFit="cover" alt={imageAltText} />
      </BackgroundImage>
    </ImageContainer>
    <TitleContainer>
      <Text size="xl">{title}</Text>
    </TitleContainer>
  </CardContainer>
);

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ImageContainer = styled.div`
  border-radius: ${getRadii('small')} ${getRadii('small')} 0 0;
  height: ${pxToRem(275)};
  padding: ${getSpace('normal1')} ${getSpace('normal2')};
  display: flex;
  align-items: flex-end;
  position: relative;
  overflow: hidden;
  width: 100%;
`;

const BackgroundImage = styled.div`
  height: 100%;
  width: 100%;
  left: 0;
  position: absolute;
  top: 0;
  pointer-events: none;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 100%;
  height: ${pxToRem(69)};
  background-color: ${getColor('base000')};
  border-radius: 0 0 ${getRadii('small')} ${getRadii('small')};
`;
